<mat-dialog-content>
  <img alt="" [src]="dataUri" />
  <a class="w-full text-center" [href]="dataUri" mat-button color="primary" download="qr-code.png" target="_blank">
    <rma-icon glyph="download" /> {{ 'action.download' | transloco }}
  </a>
</mat-dialog-content>
